import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import OnePayment from './OnePayment';
import Home from './Home';
import LeftSideBar from './LeftSideBar';
import TransactionForm from './TransactionForm';
import Incomplete from './Incomplete';
import Notification from './Notofication';
import TransactionSuccess from './TransactionSuccess/TransactionSuccess';
import BottomNav from './BottomNav';

import './MainContent.css';

function MainContent({ way }) {
  const allRequests = useSelector(state => state.requestState?.requests)
  const sessionUser = useSelector(state => state.session.user);
  const payment = useSelector(state => state.paymentState?.payments);
  const users = [];
  const [usersObj, setUsersObj] = useState([]);

  useEffect(() => {
    // No backend: load users from userService
    import('../../utils/userService').then(({ userService }) => {
      setUsersObj(userService.getAllUsers());
    });
  }, []);

  usersObj.forEach((user, i) => {
    let userObj = {};
    userObj[user.id] = user.name;
    users.push(userObj);
  })

  // console.log('users from main content',users)

  if (way === 'onePayment') {
    return (
      <div className='main-container'>
        <div className='left-side-bar'>
          <LeftSideBar />
        </div>
        <div className='main-content'>
          <OnePayment payment={payment} sessionUser={sessionUser} users={users}/>
        </div>
      </div>
    )
  };

  if (way === 'home') {
    return (
      <div>
        <div className='main-container'>
          <div className='left-side-bar'>
            <LeftSideBar />
          </div>
          <div className='main-content'>
            <Home />
          </div>
        </div>
        <BottomNav />
      </div>
    )
  };

  if (way === 'form') {
    return (
      <div>
        <div className='main-container'>
          <div className='left-side-bar'>
            <LeftSideBar />
          </div>
          <div className='main-content'>
            <TransactionForm />
          </div>
        </div>
        <BottomNav />
      </div>
    )
  };

  if (way === 'incomplete') {
    return (
      <div>
        <div className='main-container'>
          <div className='left-side-bar'>
            <LeftSideBar />
          </div>
          <div className='main-content'>
            <Incomplete allRequests={allRequests} sessionUser={sessionUser} users={users}/>
          </div>
        </div>
        <BottomNav />
      </div>
    )
  };

  if (way === 'notification') {
    return (
      <div>
        <div className='main-container'>
          <div className='left-side-bar'>
            <LeftSideBar />
          </div>
          <div className='main-content'>
            <Notification allRequests={allRequests} sessionUser={sessionUser} users={users}/>
          </div>
        </div>
        <BottomNav />
      </div>
    )
  };

  if (way === 'success') {
    return (
      <div>
        <div className='main-container'>
          <div className='left-side-bar'>
            <LeftSideBar />
          </div>
          <div className='main-content'>
            <TransactionSuccess />
          </div>
        </div>
        <BottomNav />
      </div>
    )
  };
};

export default MainContent;
